import axios, { AxiosRequestConfig } from 'axios';

import { PhotoShootData, UploadImagesData, DownloadImagesData, PhotoShootLinkData } from './types';

const mipsAgent = axios.create({
  baseURL: process.env.MERCHANT_IMAGE_PIPELINE_SERVICE_URI,
});

export const PHOTO_SHOOT_BASE_URL = '/photo-shoot/v1';

const setRequestConfig = (token: string | null): AxiosRequestConfig | undefined => {
  if (!token) {
    return undefined;
  }
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const getPhotoShoot = (venueId: string, token: string | null) =>
  mipsAgent.get<PhotoShootData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}`, setRequestConfig(token)).then(res => res.data);

export const getPhotoShootLink = (venueId: string) =>
  mipsAgent.get<PhotoShootLinkData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}/link`).then(res => res.data);

export const generateUploadUrls = async (venueId: string, fileNames: string[], token: string | null) =>
  mipsAgent
    .post<UploadImagesData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}/images/upload`, { fileNames }, setRequestConfig(token))
    .then(res => res.data);

export const downloadImages = (venueId: string, fileIds: string[], token: string | null) =>
  mipsAgent
    .post<DownloadImagesData>(
      `${PHOTO_SHOOT_BASE_URL}/${venueId}/images/download`,
      { fileIds },
      setRequestConfig(token),
    )
    .then(res => res.data);

export const deleteImage = (venueId: string, photoId: string, token: string | null) =>
  mipsAgent.delete<PhotoShootData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}/images/${photoId}`, setRequestConfig(token));

export const submitPhotoShoot = (venueId: string, token: string | null) =>
  mipsAgent.post<PhotoShootData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}/notify`, undefined, setRequestConfig(token));

export const approvePhotoShoot = (venueId: string, token: string | null) =>
  mipsAgent.post<PhotoShootData>(`${PHOTO_SHOOT_BASE_URL}/${venueId}/approve`, undefined, setRequestConfig(token));

export const linkImagesWithMenuItem = (venueId: string, itemId: string, imageIds: string[], token: string | null) =>
  mipsAgent.post<PhotoShootData>(
    `${PHOTO_SHOOT_BASE_URL}/${venueId}/items/${itemId}/images`,
    { imageIds },
    setRequestConfig(token),
  );

export const unlinkImageFromMenuItem = (venueId: string, itemId: string, imageId: string, token: string | null) =>
  mipsAgent.delete<PhotoShootData>(
    `${PHOTO_SHOOT_BASE_URL}/${venueId}/items/${itemId}/images/${imageId}`,
    setRequestConfig(token),
  );

export default mipsAgent;
